import { FRONTEND_SETTINGS_SET } from 'store/actions/frontendSettings'

const initialState = {
  hasLoaded: false
}

const frontendSettingsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case FRONTEND_SETTINGS_SET:
      const { data } = payload
      return { ...state, hasLoaded: true, ...data }
    default:
      return state
  }
}

export default frontendSettingsReducer
